import { inject, Service } from "@angular/core";

import { DataEntryDetails, MainResponseModel } from "../models";
import { MainService } from ".";

@Service()
export class BenchmarkEntryApiService {
  private _mainService = inject(MainService);

  public getByItemId(itemId: number) {
    return this._mainService.sendRequest<MainResponseModel<DataEntryDetails>>({
      url: `kpi-benchmark-entry/getByItemId/${itemId}`,
      method: "GET",
    });
  }

  public updateBenchmark(dataEntry: DataEntryDetails) {
    return this._mainService.sendRequest<MainResponseModel>({
      url: `kpi-benchmark-entry/updateBenchmark`,
      method: "POST",
      data: dataEntry,
    });
  }
}
